import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';

import { configImagesUrlSelector } from 'shared/app/state/selectors/config';
import { accountsMessages } from 'shared/app/messages/accounts';

import LoyaltyCard from '../shared/loyalty-card';
import JoinInAppCTA from '../../rewards-page/getting-started/join-in-app';
import messages from './messages';
import styles from './styles.cssm';

const GetStarted = () => {
  const imageBaseUrl = useSelector(configImagesUrlSelector);
  return (
    <ContentColumn className={`sb-global-gutters--maxWidthLayout`} size="xl">
      <div className="py9">
        <LoyaltyCard
          containerClasses="bg-whiteBackgroundSurfacePrimary3 px3 py6 md-p6"
          disableBoxShadow
        >
          <div className={`flex ${styles.container} ${styles.card}`}>
            <div className={`${styles.columns} text-center lg-text-left`}>
              <ImageLoader
                role="presentation"
                src={`${imageBaseUrl}/rewards/getting-started/sr6-get-started.png`}
                width="457"
              />
            </div>
            <div className={`${styles.columns}`}>
              <ContentColumn
                className={`${styles.zeroPadding}`}
                innerClassName="text-center"
              >
                <div className="md-px9">
                  <Heading
                    className="text-bold color-greenOnPrimary pt6 pb2 lg-pt5 md-pb3"
                    size="lg"
                    tagName="h2"
                  >
                    <FormattedMessage {...messages.getStartedHeader} />
                  </Heading>
                  <p className="color-greenOnPrimary">
                    <FormattedMessage
                      {...messages.getStartedBody}
                      values={{
                        joinInApp: (
                          <span className="text-semibold">
                            <JoinInAppCTA lowercase />
                          </span>
                        ),
                        joinNow: (content) => (
                          <a
                            className="color-greenStarbucks text-semibold"
                            href="/account/create"
                          >
                            {content}
                          </a>
                        ),
                      }}
                    />
                  </p>
                </div>
                <ContentColumn
                  className={` ${styles.zeroPadding}`}
                  innerClassName={`${styles.innerContainer} pt5`}
                >
                  <div className={`${styles.innerColumns}`}>
                    <ImageLoader
                      role="presentation"
                      src={`${imageBaseUrl}/rewards/getting-started/account.svg`}
                    />
                    <Heading
                      className="text-bold color-greenOnPrimary pt1 mx3 md-mx9 lg-mx5"
                      size="xs"
                      tagName="h3"
                    >
                      <FormattedMessage {...accountsMessages.createAnAccount} />
                    </Heading>
                  </div>
                  <div
                    className={`${styles.innerColumns} ${styles.orderAndPay}`}
                  >
                    <ImageLoader
                      role="presentation"
                      src={`${imageBaseUrl}/rewards/getting-started/card.svg`}
                    />
                    <Heading
                      className="text-bold color-greenOnPrimary pt1 md-mx9 lg-mx5"
                      size="xs"
                      tagName="h3"
                    >
                      <FormattedMessage {...messages.orderAndPay} />
                    </Heading>
                  </div>
                  <div className={`${styles.innerColumns}`}>
                    <ImageLoader
                      role="presentation"
                      src={`${imageBaseUrl}/rewards/getting-started/threeStars.svg`}
                    />
                    <Heading
                      className="text-bold color-greenOnPrimary pt1 mx2 md-mx7 lg-mx4"
                      size="xs"
                      tagName="h3"
                    >
                      <FormattedMessage {...messages.earnStarsGetRewards} />
                    </Heading>
                  </div>
                </ContentColumn>
              </ContentColumn>
            </div>
          </div>
        </LoyaltyCard>
      </div>
    </ContentColumn>
  );
};

export default GetStarted;
